import React from "react";
import styles from "./intentions-page.module.css";
import { Page } from "../../components/page/page";

const IntentionsPage = () => {
  return (
    <div className={styles.container_page}>
      <Page
        title="Before you pick your Tarot cards, take a moment to set your intentions:"
        nextPageLink="../choose-cards"
      >
        <div>
          <p className={styles.text}>
            Mother Nature, my Spirit Guide, Guardian Angels, and Spirits of the
            Earth, I ask for your help and guidance with this Love reading.
          </p>
          <p className={styles.text}>
            Guard me with a circle of white, joyous light – encapsulated in
            shimmering purple – and send my grounding cord deep into the Earth.
          </p>
          <p className={styles.text}>
            Please speak to me through this love Tarot card reading and guide me
            on my journey towards an answer.
          </p>
        </div>
      </Page>
    </div>
  );
};

export { IntentionsPage };
